var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVpayLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 63,
    viewBox: "0 0 169 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4240_2285)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.8797 27.2695H7.67076C9.35034 27.2695 10.694 25.9084 10.694 24.207C10.694 22.5056 9.35034 21.1445 7.67076 21.1445H3.8797C2.20011 21.1445 0.856445 22.5056 0.856445 24.207C0.856445 25.9084 2.20011 27.2695 3.8797 27.2695Z",
    fill: "url(#paint0_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.905273 2.96528C0.905273 4.42361 1.91302 5.59028 3.30468 5.88194C3.30468 5.93056 3.44864 5.93056 3.68858 5.97917H9.92704C12.3264 5.97917 14.4859 8.16667 15.5416 10.4028L15.7336 10.7917C16.0695 11.6181 16.4534 12.5417 16.8853 13.5625C16.8853 13.6111 16.9333 13.6111 16.9333 13.6597C18.5169 17.4028 21.0123 18.1319 24.9953 18.1319H32.2415H40.5435L35.5527 6.61111L35.2168 5.88194C35.0248 5.44444 34.7849 5.00694 34.5449 4.61806C33.6332 3.20833 32.4335 2.04167 30.9458 1.21528C30.8978 1.21528 30.8499 1.16667 30.8499 1.16667C30.8019 1.16667 30.7539 1.11806 30.7059 1.11806C29.8901 0.680556 29.1223 0.4375 28.4505 0.291667C27.4907 0 26.8189 0 26.8189 0H26.195H10.3109H3.78456H3.6406C2.10498 0.0972222 0.905273 1.36111 0.905273 2.96528Z",
    fill: "url(#paint1_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3627 56.5343C54.4106 56.4857 54.4106 56.4371 54.4586 56.3884C55.0345 55.3676 58.8256 46.2287 58.8256 46.2287C58.8256 46.2287 59.3054 44.9648 58.5376 43.701C58.1537 43.0204 57.194 42.2426 56.0422 42.2912H55.8503H29.8887H28.785H27.1534H26.6255H26.4816C26.2896 42.2912 26.1936 42.3398 26.0976 42.3398C24.754 42.5829 23.6982 43.7982 23.6982 45.2565C23.6982 46.8607 24.9939 48.2218 26.6255 48.2218C26.6735 48.2218 26.7215 48.2218 26.7695 48.2218H28.1611C30.4166 48.2218 32.4801 50.4579 33.4398 52.5482L35.4073 56.7287C36.943 60.4718 40.5901 63.0968 44.861 63.0968C49.1799 62.9996 52.827 60.3259 54.3627 56.5343Z",
    fill: "url(#paint2_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2745 2.96528C55.2745 3.40278 55.1785 3.84028 54.9865 4.18056C54.9865 4.22917 54.9385 4.27778 54.9385 4.32639C54.9385 4.375 54.1227 6.17361 54.1227 6.22222L49.084 18.0833H70.8226C73.078 12.8333 75.1415 7.92361 76.8211 3.98611C77.6369 2.09028 76.1013 0 74.0858 0H63.9123H58.2977H52.4432C54.0268 0.0486111 55.2745 1.36111 55.2745 2.96528Z",
    fill: "url(#paint3_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6107 31.8893L26.0023 34.7574C26.0983 34.9518 26.2423 35.2435 26.3862 35.5352C26.5302 35.8268 26.6742 36.1185 26.8661 36.3615C26.9621 36.556 27.1061 36.7504 27.202 36.8963C28.6417 38.7921 31.281 39.181 33.7764 39.181H40.8786H61.4655H61.7055C63.481 35.0977 65.4006 30.5282 67.3201 26.056C67.656 25.3268 67.896 24.6949 67.896 24.1602C67.848 21.924 66.0724 21.1463 64.9687 21.1463H64.2009H47.9329C47.8369 21.1463 47.7409 21.1949 47.693 21.2921L45.0056 27.5629C44.9096 27.7574 44.6217 27.7574 44.5257 27.5629L43.9019 26.4449C43.8059 26.2504 43.7099 26.1046 43.614 25.9102C43.0381 24.9379 42.3183 24.1115 41.5025 23.431C39.8709 22.0699 37.8074 21.1949 35.5999 21.0977C35.456 21.0977 35.36 21.0977 35.216 21.0977H26.7701H20.1478H16.6926C15.109 21.1463 13.8613 22.4588 13.8613 24.0629C13.8613 25.5213 14.9171 26.7365 16.2607 26.9796C16.3087 27.0282 16.4527 27.0282 16.6926 27.0282H19.428C21.8274 27.0282 23.411 29.2157 24.4667 31.4032L24.6107 31.8893Z",
    fill: "url(#paint4_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.186 26.931L145.732 5.34766H141.941L153.363 30.8199L151.107 35.681C150.099 37.8685 149.188 39.3268 147.028 39.3268C146.212 39.3268 145.445 39.181 144.869 38.8893L144.485 41.7574C145.301 42.1463 146.452 42.3407 147.556 42.3407C151.347 42.3407 152.931 39.9102 154.514 36.1671L168.143 5.34766H164.352L155.186 26.931Z",
    fill: "url(#paint5_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.299 10.5486C122.074 8.70139 124.234 7.68055 127.257 7.68055C131.912 7.68055 134.839 10.6458 134.839 15.3125V17.1111C132.44 16.5278 129.8 16.2361 127.449 16.2361C121.211 16.2361 117.036 19.3958 117.036 24.0625C117.036 28.5833 120.395 31.5486 125.434 31.5486C129.465 31.5486 133.064 29.4097 134.887 25.6667L134.983 31.0625H138.342V14.875C138.342 8.84722 134.311 4.8125 128.073 4.8125C123.994 4.8125 121.019 6.07639 118.667 8.36111L120.299 10.5486ZM126.393 28.9722C122.842 28.9722 120.683 27.0278 120.683 24.0139C120.683 20.9028 123.562 18.8125 127.881 18.8125C130.088 18.8125 132.584 19.1042 134.839 19.6389C134.887 25.618 130.424 28.9722 126.393 28.9722Z",
    fill: "url(#paint6_linear_4240_2285)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6427 25.5694C92.3702 29.2153 95.7294 31.5972 100.816 31.5972C107.918 31.5972 113.005 26.25 113.005 18.1319C113.005 10.1597 107.966 4.8125 100.816 4.8125C95.7774 4.8125 92.3702 7.19444 90.6427 10.8403L90.5467 5.29861H87.1875V41.8056H90.6427V25.5694ZM100 7.875C105.615 7.875 109.406 11.9583 109.406 18.1806C109.406 24.4028 105.663 28.5833 100 28.5833C94.4337 28.5833 90.6427 24.4514 90.6427 18.2292C90.6427 12.0069 94.3857 7.875 100 7.875Z",
    fill: "url(#paint7_linear_4240_2285)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4240_2285",
    x1: 0.85912,
    y1: 24.204,
    x2: 77.0294,
    y2: 24.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4240_2285",
    x1: 0.890428,
    y1: 9.03586,
    x2: 77.0607,
    y2: 9.03586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4240_2285",
    x1: 0.858567,
    y1: 52.6457,
    x2: 77.0288,
    y2: 52.6457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4240_2285",
    x1: 0.858604,
    y1: 9.03586,
    x2: 77.0288,
    y2: 9.03586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4240_2285",
    x1: 0.859222,
    y1: 30.1702,
    x2: 77.0295,
    y2: 30.1702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7941F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4240_2285",
    x1: 87.1715,
    y1: 23.8127,
    x2: 168.134,
    y2: 23.8127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4240_2285",
    x1: 87.1715,
    y1: 18.2025,
    x2: 168.134,
    y2: 18.2025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4240_2285",
    x1: 87.172,
    y1: 23.3202,
    x2: 168.134,
    y2: 23.3202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB3881"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5682,
    stopColor: "#ED2B30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4240_2285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.287,
    height: 63,
    fill: "white",
    transform: "translate(0.856445)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVpayLogo);
export default __webpack_public_path__ + "static/media/vpay-logo.0ce6830d940c8a3a1a91ac49c240ad9e.svg";
export { ForwardRef as ReactComponent };